/**
 * Único sitio donde hace falta tocar la empresa A3 para el CRM (gastos usuario: proveedores + post-a3).
 *
 * En el front, .env:
 *   REACT_APP_A3_DEFAULT_DB_SOURCE=STAGE_DESIGN
 * o LELO / ERNA_TRADE / NML_SPAIN
 *
 * El endpoint post-a3 del back usa solo el `dbSource` que envía esta app (no `A3_DEFAULT_DB_SOURCE` del servidor).
 */
const raw = process.env.REACT_APP_A3_DEFAULT_DB_SOURCE;
export const A3_DEFAULT_DB_SOURCE =
  raw != null && String(raw).trim() !== ""
    ? String(raw).trim()
    : "STAGE_DESIGN";
